import { breakpoints } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import styled, { css } from "styled-components";
import { colors } from "../../../../utils/colors";
import { CMSLink } from "../../../atoms/CMSLink";

export const Wrapper = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
`;

export const Title = styled.h3`
    color: white;
    font-size: 18px;
    font-weight: bold;

    ${breakpoints.large} {
        font-size: 24px;
    }
`;

export const Description = styled.p`
    color: white;
`;

export const Link = styled(CMSLink)<{ hidden?: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    text-decoration: none;
    color: ${colors.brandLight};
    font-weight: 500;

    &:not(:first-child) {
        border-top: 1px solid ${transparentize(0.75, "white")};
    }

    &:hover {
        text-decoration: underline;
    }

    ${({ hidden = false }) =>
        hidden &&
        css`
            display: none;

            ${breakpoints.large} {
                display: flex;
                visibility: hidden;
            }
        `}
`;

export const Content = styled.div`
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const Buttons = styled.div`
    margin-top: auto;
`;
